import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { bootstrapPublicSignCapability } from './utils/publicSignCapability';

const ENGLISH_OPERATOR_SURFACE = 'english_beta';
const OPERATOR_SURFACE_STORAGE_KEY = 'operator_surface';

const getRequestedOperatorSurface = () => {
  try {
    const params = new URLSearchParams(window.location.search || '');
    return (
      params.get('surface') ||
      params.get('operator_surface') ||
      window.localStorage.getItem(OPERATOR_SURFACE_STORAGE_KEY) ||
      ''
    );
  } catch (error) {
    return '';
  }
};

const applyAppTranslationGuard = () => {
  const isEnglishBeta = getRequestedOperatorSurface() === ENGLISH_OPERATOR_SURFACE;
  const rootElement = document.getElementById('root');
  const guardedElements = [document.documentElement, document.body, rootElement].filter(Boolean);

  document.documentElement.lang = isEnglishBeta ? 'en' : 'ja';

  guardedElements.forEach((element) => {
    element.setAttribute('translate', 'no');
    element.classList.add('notranslate');
  });

  if (!document.querySelector('meta[name="google"][content="notranslate"]')) {
    const meta = document.createElement('meta');
    meta.name = 'google';
    meta.content = 'notranslate';
    document.head.appendChild(meta);
  }
};

// Capture a signing capability from the URL fragment and remove it from the
// visible history entry before React, routing, analytics, or PDF code mounts.
bootstrapPublicSignCapability();
applyAppTranslationGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
